import GCSScore from "../../components/GCSScore/GCSScore";
import SOFAScore from "../../components/SOFAScore/SOFAScore";
import BedDetails from "../../pages/bedDetails/BedDetails";
import HomePage from "../../pages/homepage/Homepage";
import Login from "../../pages/login/Login";
import SOFAScorePage from "../../pages/SOFAScore/SOFAScorePage";
import GCSScorePage from "../../pages/GCSScore/GCSScorePage";
import MorseFallRiskPage from "../../pages/MorseFallRisk/MorseFallRiskPage";
import PatientBook from "../../pages/PatientBook/PatientBook";
import BradenScorePage from "../../pages/BradenScore/BradenScorePage";
import RASSScorePage from "../../pages/RASSScore/RASSScorePage";
import Apache2Page from "../../pages/Apache2/Apache2Page";

export const routes = [{
    key: "login",
    path: '/login',
    exact: true,
    authNeeded: false,
    element: <Login />
}, {
    key: 'homepage',
    path: '/home-page',
    exact: true,
    authNeeded: true,
    element: <HomePage />
}, {
    key: 'patient-book',
    path: '/patient-book',
    exact: true,
    authNeeded: true,
    element: <PatientBook />
}, {
    key: 'homepage',
    path: '/bed-details/:id',
    exact: true,
    authNeeded: true,
    element: <BedDetails />
}, {
    key: 'gcs-score',
    path: '/gcs-score/:id',
    exact: true,
    authNeeded: true,
    element: <GCSScorePage />
}, {
    key: 'sofa-score',
    path: '/sofa-score/:id',
    exact: true,
    authNeeded: true,
    element: <SOFAScorePage />
}, {
    key: 'fall-risk-score',
    path: '/fall-risk/:id',
    exact: true,
    authNeeded: true,
    element: <MorseFallRiskPage />
}, {
    key: 'braden-score',
    path: '/braden-score/:id',
    exact: true,
    authNeeded: true,
    element: <BradenScorePage />
}, {
    key: 'rass-score',
    path: '/rass-score/:id',
    exact: true,
    authNeeded: true,
    element: <RASSScorePage />
},
{
    key: 'apache-2-score',
    path: '/apache-2-score/:id',
    exact: true,
    authNeeded: true,
    element: <Apache2Page />
}
]
